import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import api from "@/api";

export default function AdminReports() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/search-logs").then(({ data }) => setLogs(data)).catch(() => setLogs([])); }, []);
  const exportCsv = (kind) => api.get(`/admin/export/${kind}`, { responseType: "blob" }).then((r) => {
    const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = `${kind}.csv`; a.click();
  });
  return (
    <div data-testid="admin-reports" className="max-w-3xl">
      <h1 className="font-serif text-3xl mb-6">Reports & Export</h1>
      <div className="bg-white border border-[#E5DEC9] p-6 mb-6">
        <p className="font-serif text-xl mb-2">Data Export (Backup / Migration)</p>
        <p className="text-xs text-[#8C7A5E] mb-4">Download clean CSV exports — also used for future WooCommerce migration.</p>
        <div className="flex flex-wrap gap-2">
          {["products", "orders", "customers"].map((k) => (
            <button key={k} onClick={() => exportCsv(k)} data-testid={`export-${k}`} className="tq-btn-outline !py-2.5 capitalize"><Download size={14} /> {k}</button>
          ))}
        </div>
      </div>
      <div className="bg-white border border-[#E5DEC9] p-6">
        <p className="font-serif text-xl mb-1">Zero-Result Searches</p>
        <p className="text-xs text-[#8C7A5E] mb-4">What customers searched for but didn't find — stock these to capture demand.</p>
        {!logs ? <div className="h-24 bg-[#F4EFE6] animate-pulse" /> : logs.length === 0 ? (
          <p className="text-sm text-[#9a938a]">No zero-result searches recorded.</p>
        ) : (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-[10px] uppercase tracking-[0.15em] text-[#8C7A5E] border-b border-[#E5DEC9]"><th className="py-2">Query</th><th className="py-2">Count</th><th className="py-2">Last searched</th></tr></thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.q} className="border-b border-[#F4EFE6]">
                  <td className="py-2.5 font-medium">"{l.q}"</td>
                  <td className="py-2.5">{l.count}</td>
                  <td className="py-2.5 text-xs text-[#9a938a]">{new Date(l.at).toLocaleDateString("en-IN", { day: "numeric", month: "short" })}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
